module.exports = __webpack_public_path__ + "img/info_banner01.6f1b7ca9.webp";